import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './services/loading.service';

let totalRequests = 0;
let completedRequests = 0;

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoadingService);
  totalRequests++;
  loader.setDataProgress(completedRequests, totalRequests);

  return next(req).pipe(
    finalize(() => {
      completedRequests++;
      loader.setDataProgress(completedRequests, totalRequests);
    })
  );
};
